import React from 'react'
import PropTypes from 'prop-types'

import ModalBody from 'components/Utils/Modal/Body'
import ModalWrapper from 'components/Utils/Modal/Wrapper'
import { Button, Text } from 'components/base'
import enhance from './enhance'
import Illustration from './illustration.png'

const TEXT = {
  title: 'You & Slite',
  description:
    'At Slite, transparency is one of our pillars. So let’s be fully transparent about the data we collect and how we use it to give you the best experience.',
  content: (
    <div className="line-height-larger">
      <h2 className="font-size-large font-weight-medium">
        What data do we collect?
      </h2>
      <p className="shade-10 padding-top-normal padding-bottom-large">
        As you know, Slite is a doc app for teams, which means we need to
        collect some information about our users for the app to function well
        and bring you value. We must store information about users to enable
        invitations, sign ins and password retrievals. This information also
        allows team members to recognize each other and enables collaborative
        features such as comments, pings and docs history.
      </p>

      <h2 className="font-size-large font-weight-medium">
        Why are we collecting data?
      </h2>
      <p className="shade-10 padding-top-normal padding-bottom-large">
        So exactly what information are we collecting? For one, the information
        that you fill out when you sign in: your email, name, company position
        and company role. This information is also accessible to your team. For
        public docs, we collect the author name and avatar. Finally, when you
        choose to sign up with Google, we collect the team emails and names of
        your domain to make it easier to invite your team.
      </p>

      <h2 className="font-size-large font-weight-medium">
        Do we share this data with third parties?
      </h2>
      <p className="shade-10 padding-top-normal padding-bottom-large">
        For analytics and product development purposes, we send this data to
        third party services. Moreover, the information we collect gives us the
        means to offer quality customer support. Speaking to our users has
        helped us improve product quality and development from day 1. Finally,
        we only use GDRP-compliant services such as Algolia for our search or
        Forest for our back-office. This ensures these parts are top quality
        while remaining secure for our users.
      </p>

      <p className="shade-10">
        Even though we're a small company, we're growing and we have a mission:
        re-invent document collaboration. This can only happen if we're 100%
        confident with our security level. We've already started to invest in it
        and will continue to in the coming month. To follow our privacy page, be
        sure to read{' '}
        <a className="primary underline" href="https://slite.com/privacy">
          https://slite.com/privacy
        </a>{' '}
        that we will be updating as we progress.
        {' ❤️🔑 '}
      </p>
    </div>
  ),
}

export class Privacy extends React.Component {
  static propTypes = {
    shouldDisplayPrivacyModal: PropTypes.bool.isRequired,
    updateUserPreferences: PropTypes.func.isRequired,
  }

  onClickAgree = () => {
    this.props.updateUserPreferences({
      acceptedPrivacyPolicyAt: new Date().toISOString(),
    })
  }

  render() {
    const { shouldDisplayPrivacyModal } = this.props

    if (!shouldDisplayPrivacyModal) {
      return false
    }

    return (
      <ModalWrapper preventClose onModalClose={() => {}}>
        <ModalBody style={{ padding: 0 }}>
          {/* Header */}
          <div
            className="flexbox flexbox-space-between padding-top-huge padding-horizontal-huge padding-bottom-largest"
            style={{
              backgroundColor: 'rgba(170, 231, 237, .2)',
            }}
          >
            <div className="padding-right-larger">
              <Text.Title>{TEXT.title}</Text.Title>
              <div className="shade-20 line-height-larger">
                {TEXT.description}
              </div>
            </div>
            <div className="">
              <img
                alt="slite-privacy-users"
                src={Illustration}
                style={{ width: 176 }}
              />
            </div>
          </div>

          <div className="padding-vertical-largest padding-horizontal-huge">
            {/* Content */}
            <div className="flexbox flexbox-space-between padding-bottom-larger">
              {TEXT.content}
            </div>

            {/* Footer */}
            <div className="flexbox flexbox-space-between">
              <Button.Secondary
                href="https://slite.com/privacy"
                target="_blank"
              >
                Learn more
              </Button.Secondary>

              <Button.Primary onClick={this.onClickAgree}>
                Agree and continue using Slite
              </Button.Primary>
            </div>
          </div>
        </ModalBody>
      </ModalWrapper>
    )
  }
}

export default enhance(Privacy)
